export enum ViewMode {
  GRID = 'grid',
  LIST = 'list',
}

export interface ShortcutLink {
  id: string;
  name: string;
  description: string;
  url: string;
  isFavorite?: boolean;
  userShortcutLinkId?: number;
  isCustom?: boolean;
}

export interface FavoriteShortcut {
  link: ShortcutLink;
  section: ShortcutSection;
}

export interface ShortcutSection {
  id: string;
  title: string;
  icon: React.ElementType;
  links: ShortcutLink[];
}
